import { ScheduledPayment } from './compensation-history-model';

export function getCurrentScheduledPayment(allScheduledpayments: ScheduledPayment[]) {
	return allScheduledpayments[0];
}

export function getScheduledPaymentById(allScheduledpayments: ScheduledPayment[], id: string) {
	return allScheduledpayments.filter(a => a.id.toString() === id)[0];
}